import {
    addDoc,
    collection,
    doc,
    getDoc,
    getDocs,
    deleteDoc,
    query,
    setDoc,
    where,
    orderBy,
    limit,
    startAt,
    endAt, startAfter,
} from "firebase/firestore";
import Promise from "bluebird";
import * as _ from "lodash";
import {fireStoreDB} from "../../firebase/client-app";
import {DATA_LIMIT} from "../../common/constants/quote.constant";

export {
    addDesigns,
    addSingleDesign,
    updateDesigns,
    updateSingleDesign,
    deleteSingleDesign,
    getSingleDesign,
    getSingleDesignById,
    searchDesigns,
    getAllDesigns,
    getDesignsList,
    prepareDesignsList,
    prepareDesignData,
}

const collectionName = 'designs';
const collectionReference = collection(fireStoreDB, collectionName);

const addDesigns = (designs) => {
    return Promise.map(designs, async design => {
        console.log('.');
        await addSingleDesign(design);
    });
}

const updateDesigns = (designs) => {
    return Promise.each(designs, async design => {
        console.log('.');
        await updateSingleDesign(design);
    });
}

const addSingleDesign = (design) => {
    design.createdAt = new Date();
    design.updatedAt = design.createdAt;
    return addDoc(collectionReference, design);
}

const updateSingleDesign = (design) => {
    const documentReference = doc(fireStoreDB, collectionName, design.id);
    design.updatedAt = new Date();
    return setDoc(documentReference, design, {merge: true});
}

const deleteSingleDesign = (design) => {
    const documentReference = doc(fireStoreDB, collectionName, design.id);
    return deleteDoc(documentReference);
}

const getSingleDesign = (designId) => {
    const documentReference = doc(fireStoreDB, collectionName, designId);
    return getDoc(documentReference);
}

const getSingleDesignById = async (designId) => {
    const documentReference = doc(fireStoreDB, collectionName, designId);
    const designResult = await getDoc(documentReference);
    return prepareDesignData(designResult);
}

const getTotalItemsCount = async () => {
    const totalItemsQuery = query(collectionReference);
    const totalItemsResult = await getDocs(totalItemsQuery);
    return totalItemsResult.size;
}

const searchDesigns = async (searchCriteriaList, itemsPerPage = DATA_LIMIT, currentPage = 0) => {
    let searchQuery = query(collectionReference);

    _.forEach(searchCriteriaList, searchCriteria => {
        searchQuery = query(searchQuery,
            where(searchCriteria.field, searchCriteria.condition, searchCriteria.value));
    });

    searchQuery = query(searchQuery,
        orderBy('updatedAt', 'desc'));

    if (itemsPerPage > 0) {
        searchQuery = query(searchQuery, limit(itemsPerPage));
    }

    /*if (currentPage > 0) {
        const startIndex = (currentPage - 1) * itemsPerPage;
        const endIndex = startIndex + itemsPerPage - 1;

        searchQuery = query(searchQuery, startAfter(startIndex));
        // searchQuery = query(searchQuery, endAt(endIndex));

        console.log('searchQuery', searchQuery);
        console.log('startIndex', startIndex);
        console.log('endIndex', endIndex);
    }*/

    const designResult = await getDocs(searchQuery);
    return prepareDesignsList(designResult);
}

const getAllDesigns = async (designId) => {
    let searchQuery = query(collectionReference,
        where("designId", "==", designId));

    const designResult = await getDocs(searchQuery);
    return prepareDesignsList(designResult);
}

const getDesignsList = async (designIds) => {
    let searchQuery = query(collectionReference,
        where("id", "in", designIds));

    const designResult = await getDocs(searchQuery);
    return prepareDesignsList(designResult);
}

const prepareDesignsList = (designResult) => {
    const designsList = [];

    _.forEach(designResult.docs, designDoc => {
        designsList.push(prepareDesignData(designDoc));
    });

    return designsList;
}

const prepareDesignData = (designDoc) => {
    if (!designDoc.exists) {
        return null;
    }

    return {
        ...designDoc.data(),
        id: designDoc.id
    }
}
